import { StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Radius, Spacing } from '@/constants/theme';
import { useTheme } from '@/hooks/use-theme';
import { features } from '@/lib/events-data';

import css from './feature-strip.module.css';

// Web-only: column count used to be a JS `isLg`/`isSm` check plus a measured
// `itemWidth` (onLayout), so it rendered 1 column, then remeasured to 2 or 4
// after mount — a visible height jump on top of the earlier width flash.
// CSS grid (feature-strip.module.css) picks the column count with the same
// breakpoints, resolved by the browser at first paint.
export function FeatureStrip() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className={css.wrap}>
      <View style={[styles.section, { backgroundColor: theme.secondary }]}>
        <div className={css.grid}>
          {features.map((feature) => (
            <View key={feature.id} style={styles.row}>
              <View style={[styles.iconBox, { backgroundColor: theme.card }]}>
                <feature.icon size={18} color={theme.gold} />
              </View>
              <View style={styles.textCol}>
                <Text style={[styles.title, { color: theme.text }]}>
                  {t(`features.${feature.id}.title`)}
                </Text>
                <Text style={[styles.desc, { color: theme.mutedForeground }]}>
                  {t(`features.${feature.id}.desc`)}
                </Text>
              </View>
            </View>
          ))}
        </div>
      </View>
    </div>
  );
}

const styles = StyleSheet.create({
  section: {
    borderRadius: Radius.xl,
    padding: Spacing.three,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: Spacing.two,
  },
  iconBox: {
    width: 40,
    height: 40,
    borderRadius: Radius.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textCol: {
    flex: 1,
    gap: 4,
  },
  title: {
    fontSize: 14,
    fontWeight: '700',
  },
  desc: {
    fontSize: 12,
    lineHeight: 16,
  },
});
